import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import * as authActions from 'redux/modules/auth';
import { translate } from 'react-i18next';
import { LoginForm } from 'components';

@translate(['common'])
@connect(
  state => ({ user: state.auth.user })
)
export default class Login extends Component {

  render() {
    const { user } = this.props;
    const styles = require('./Login.scss');
    const { t } = this.props;

    return (
      <div className={styles.loginPage + ' container'}>
        <Helmet title="Login" />

        {!user &&
          <LoginForm />
        }


      </div>
    );
  }
}
